module.exports = __webpack_public_path__ + "img/2022.2ccf54bc.jpg";